import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { GroupsPlaceholder } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { customScrollStyles, InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { Space } from 'STORE/Spaces/Space';

import { SpaceGroupAvailableItem } from './SpaceGroupAvailableItem/SpaceGroupAvailableItem';
import { SpaceGroupItem } from './SpaceGroupItem/SpaceGroupItem';
import { useSpacePanelGroupsPresenter } from './SpacePanelGroups.presenter';
import styles from './SpacePanelGroups.styles.m.css';

const GROUP_PLACEHOLDER_COUNT = 14;

interface ISpacePanelGroupsProps {
  space: Space;
}

export const SpacePanelGroups: FC<ISpacePanelGroupsProps> = observer(({ space }) => {
  const presenter = useSpacePanelGroupsPresenter(space);
  const { t } = useTranslation();

  if (presenter.isEmpty) {
    return (
      <InfoBlock
        className={classNames(styles.empty, customScrollStyles.container)}
        type={InfoBlockTypes.Sidebar}
        descriptions={[t('space_alert_donot_group_channel')]}
        image={getMascotImageSrc(PROJECT_CONFIG.imageAssets.notFound)}
      />
    );
  }

  return (
    <div className={classNames(styles.list, customScrollStyles.container)}>
      {presenter.subscribedGroups.map((group) => (
        <SpaceGroupItem
          key={group.id}
          group={group}
        />
      ))}

      {!presenter.isGroupsLoading &&
        presenter.availableGroups.map((group) => (
          <SpaceGroupAvailableItem
            key={group.id}
            group={group}
          />
        ))}

      {presenter.isGroupsLoading && <GroupsPlaceholder count={GROUP_PLACEHOLDER_COUNT} />}
    </div>
  );
});
